import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { Svg } from '@mlc/web-ui-toolkit';

export const SelectStyle = styled('select')`
appearance: none;
border: 0;
font-size: 14px;
height: 100%;
min-width: 100%;
outline: 0;
overflow-x: scroll;
overflow-y: scroll;
padding: 10px;
padding-right: 0;
position: relative;

@media screen and (-webkit-min-device-pixel-ratio: 0) {
	max-width: 200px;
}

option {
	padding-bottom: 0.25em;
}

option:last-child {
	padding-bottom: 0;
}
`;

export const SelectContainer = styled('div')`
background-color: ${palette.mlcWhite};
border: 1px solid ${palette.mlcMediumGrey};
box-sizing: border-box;
color: ${palette.mlcVeryDarkGrey};
height: 150px;
overflow-x: scroll;
overflow-y: hidden;
position: relative;
width: 100%;

@media screen and (-webkit-min-device-pixel-ratio: 0) {
	overflow-x: hidden;
}

&:focus,
&:hover,
&:focus-within {
	border: 1px solid ${palette.mlcAqua};
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 4px ${palette.mlcAqua};
}

@media print {
	box-shadow: none;
	color: ${palette.mlcVeryDarkGrey};
}
`;
